module.exports = __webpack_public_path__ + "static/media/feedback.39131d3a.svg";